// Polyfill ES5 stuff
// https://babeljs.io/docs/en/babel-polyfill/
import 'core-js/stable';
import 'regenerator-runtime/runtime';

import Vue from 'vue';
import IdleVue from 'idle-vue';
import Form from '../Form.vue';
import UniqueId from 'vue-unique-id';
import axios from 'axios';
import axiosRetry from 'axios-retry';
import Swal from 'sweetalert2';

import * as Sentry from '@sentry/browser';
import * as Integrations from '@sentry/integrations';

export default (config) => {
	if (process.env.NODE_ENV === 'production') {
		Sentry.init({
			dsn: 'https://48677961e825431cb8ebb2305676cbeb@o57187.ingest.sentry.io/5904947',
			integrations: [new Integrations.Vue({ Vue, attachProps: true })],
		});
	}

	const eventsHub = new Vue();

	// Set form into onsite mode when global var is present
	/* eslint-disable no-undef */
	if (typeof ONSITE !== 'undefined' && ONSITE === true) {
		config = {
			...config, ...{
				successMessage: 'Your registration was successful.<br><br>Please go to the registration counter to pick up your entry badge.',
				showConfirmButton: false,
				idleReload: true
			}
		};
	}

	// Detect user as idle if no activity for one minute
	Vue.use(IdleVue, {
		eventEmitter: eventsHub,
		idleTime: 60000,
		startAtIdle: false,
	});

	// Add unique IDs to components
	Vue.use(UniqueId);

	function mountForm() {
		new Vue({
			el: '#xpo-api-form',
			render: (h) =>
				h(Form, {
					props: {
						// Add the instance config to the form component data
						config: config,
					},
				}),
			onIdle() {
				// Redirect to idle URL if user has been idle
				/* eslint-disable no-undef */
				if (typeof IDLE_URL !== 'undefined') {
					document.location.href = IDLE_URL;
				}
				// Reload page if idleReload is set to true and user has been idle
				else if ('idleReload' in config && config.idleReload === true) {
					location.reload(true);
				}
			},
		});
	}

	// IF a closed URL constant is defined then only init form if pre-registrations haven't closed
	if (typeof CLOSED_URL !== 'undefined') {
		// Retry with exponential delay between each attempt if request fails
		// Tries up to 3 times by default
		axiosRetry(axios, {
			retries: 6,
			retryDelay: axiosRetry.exponentialDelay,
			retryCondition: () => {
				return true;
			},
		});

		axios
			.get(process.env.VUE_APP_API_URL + '/registrations/' + config.showId + '/closed')
			.then((res) => {
				if (res && Object.prototype.hasOwnProperty.call(res, 'data') && res.data.closed === true) {
					// Redirect to closed URL if closed
					document.location.href = CLOSED_URL;
				} else {
					// Otherwise init form as usual
					mountForm();
				}
			})
			.catch((err) => {
				Swal.fire(
					'Network Error',
					'Looks like you’re having trouble accessing this registration form (and we think this is due to your internet connection).<br><br>Feel free to try again later or contact us on<br>09 976 8300 or onsite at the show.',
					'error'
				);

				if (err.response) {
					// client received an error response (5xx, 4xx)
					console.log('Error in response');
				} else if (err.request) {
					// client never received a response, or request never left
					console.log('Error in request');
				} else {
					// anything else
					console.log('Unknown error');
				}

				console.error(err);
				Sentry.captureException(err);
			});
	} else {
		mountForm();
	}
};
